import { Component, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DataStorageService } from './../dataservices/data-storage.service';
@Component({
  selector: 'app-pse-register',
  templateUrl: './pse-register.component.html',
  styleUrls: ['./pse-register.component.scss']
})
export class PseRegisterComponent implements AfterViewInit {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  firstName: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  secondName: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  thirdName: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fourthName: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fifthName: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sixthName: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  seventhName: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cstmID: any;
  errseventhname = false;
  errsixthname = false;
  errfifthname = false;
  errfourthname = false;
  errthirdname = false;
  errsecondname = false;
  errfirstname = false;

  constructor(public router: Router, public route: ActivatedRoute, public dss: DataStorageService, ) {

    if (this.dss.registration != '' && this.dss.registration != undefined) {
      console.log(this.dss.user_profile_data.profile.custom_id);
      console.log(this.dss.registration + '/' + this.dss.user_profile_data.profile.custom_id);
      window.location.href = this.dss.registration + '/' + this.dss.user_profile_data.profile.custom_id;
    } else if (this.dss.registration == '' && this.dss.registration == undefined) {
      const regurl = (window.location.href.slice(window.location.href.indexOf('#') + 1).split('?')[1]);
      this.dss.registration = regurl.split('=')[1];
      window.location.href = this.dss.registration + '/' + this.dss.user_profile_data.profile.custom_id;
    }



  }

  ngAfterViewInit(): void {
    console.log(this.dss.user_profile_data);
    console.log(this.dss.registration);
  }

  submit(): void {

    if (this.firstName == '' || this.firstName == undefined) {
      this.errfirstname = true;
      this.errseventhname = false;
      this.errsixthname = false;
      this.errfifthname = false;
      this.errfourthname = false;
      this.errthirdname = false;
      this.errsecondname = false;

      const elmnt = document.getElementById('firstnamediv');
      elmnt.scrollIntoView();

      return;
    } else if (this.secondName == '' || this.secondName == undefined) {
      this.errsecondname = true;
      this.errseventhname = false;
      this.errsixthname = false;
      this.errfifthname = false;
      this.errfourthname = false;
      this.errthirdname = false;
      this.errfirstname = false;
      const elmnt = document.getElementById('secondnamediv');
      elmnt.scrollIntoView();

      return;
    } else if (this.thirdName == '' || this.thirdName == undefined) {
      this.errthirdname = true;
      this.errseventhname = false;
      this.errsixthname = false;
      this.errfifthname = false;
      this.errfourthname = false;
      this.errsecondname = false;
      this.errfirstname = false;
      const elmnt = document.getElementById('thirdnamediv');
      elmnt.scrollIntoView();

      return;
    } else if (this.fourthName == '' || this.fourthName == undefined) {
      this.errfourthname = true;
      this.errseventhname = false;
      this.errsixthname = false;
      this.errfifthname = false;
      this.errthirdname = false;
      this.errsecondname = false;
      this.errfirstname = false;
      const elmnt = document.getElementById('fourthnamediv');
      elmnt.scrollIntoView();

      return;
    } else if (this.fifthName == '' || this.fifthName == undefined) {
      this.errfifthname = true;
      this.errseventhname = false;
      this.errsixthname = false;
      this.errfourthname = false;
      this.errthirdname = false;
      this.errsecondname = false;
      this.errfirstname = false;
      const elmnt = document.getElementById('fifthnamediv');
      elmnt.scrollIntoView();

      return;
    } else if (this.sixthName == '' || this.sixthName == undefined) {
      this.errsixthname = true;
      this.errseventhname = false;
      this.errfifthname = false;
      this.errfourthname = false;
      this.errthirdname = false;
      this.errsecondname = false;
      this.errfirstname = false;
      const elmnt = document.getElementById('sixthnamediv');
      elmnt.scrollIntoView();

      return;
    } else if (this.seventhName == '' || this.seventhName == undefined) {
      this.errseventhname = true;
      this.errsixthname = false;
      this.errfifthname = false;
      this.errfourthname = false;
      this.errthirdname = false;
      this.errsecondname = false;
      this.errfirstname = false;
      const elmnt = document.getElementById('seventhnamediv');
      elmnt.scrollIntoView();

      return;
    }
    const scriptURL = 'https://script.google.com/macros/s/AKfycbyK5d4PtVWlIVXgXepTzPNJqjGg9_FnwUlcTgjq7_DEgeaOkWo/exec';
    // const form = document.forms['submit-to-google-sheet'];
    // const loading = document.querySelector('.js-loading');
    // const successMessage = document.querySelector('.js-success-message');
    // const errorMessage = document.querySelector('.js-error-message');

    const formData = new FormData();

    formData.append('CUSTOM ID', this.cstmID);
    formData.append('FIRST NAME', this.firstName);
    formData.append('SECOND NAME', this.secondName);
    formData.append('THIRD NAME', this.thirdName);
    formData.append('FOURTH NAME', this.fourthName);
    formData.append('FIFTH NAME', this.fifthName);
    formData.append('SIXTH NAME', this.sixthName);
    formData.append('SEVENTH NAME', this.seventhName);



    fetch(scriptURL, { method: 'POST', body: formData });
    //         fetch(scriptURL, { method: 'POST', body:formData})
    this.router.navigateByUrl('thankyou');
  }

}
